/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ActionCondition from 'cio/app-models/conditions/action';
import Component from '@glimmer/component';

interface Args {
  condition: ActionCondition;
  disabled: boolean;
  size: string;
  classNames?: string[];
}

export default class LinkHref extends Component<Args> {}
